import { ISlot } from '@Reducers/slot/types';
import { useCallback, useState } from 'react';
import useConsultationType from './consultation-type';
import { ScheduleService } from '@Services';
import { IQueryData } from '@Reducers/common';
import { useAppSelector } from '@Redux/hooks';

const useHoldSlot = () => {
  const { consultationType, locationType } = useConsultationType();
  const queryData: IQueryData = useAppSelector((state) => state.common.queryData);
  const [isLoading, setIsLoading] = useState(false);

  const holdSlot = useCallback(
    async (slot: ISlot) => {
      setIsLoading(true);
      if (slot.blockId) {
        const response = await ScheduleService.HoldSlot({
          blockId: slot.blockId,
          endDate: slot.endDate,
          startDate: slot.startDate,
          consultationTypeId: consultationType?.consultationTypeId,
          locationId: locationType?.id,
          providerIds: queryData?.providerId,
          excludedProviderIds: queryData?.excludedProviderId,
          preferredLanguages: queryData?.selectedLanguages,
          speciality: queryData?.speciality,
        });

        setIsLoading(false);

        if (response.status === 201) {
          return true;
        } else {
          throw new Error('Slot is not available');
        }
      }
    },
    [consultationType, locationType, queryData],
  );

  return { holdSlot, isLoading };
};

export default useHoldSlot;
